import { Behavior } from '../entities/Behavior';

/**
 * Rotates its entity at a constant rate.
 *
 * One line of logic and one number of configuration, kept in the engine rather than copied into every
 * game because a spinning coin, a spinning loading badge and a spinning wheel are the same behavior.
 */
export class Spin extends Behavior {
  readonly #radiansPerSecond: number;

  constructor(radiansPerSecond: number) {
    super();
    this.#radiansPerSecond = radiansPerSecond;
  }

  /** Advances the rotation by one frame. */
  override onUpdate(deltaSeconds: number): void {
    this.entity.transform.rotation += this.#radiansPerSecond * deltaSeconds;
  }
}
